import { Box, Link } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import useNavigateTo, { NavigateToOptions } from "../../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../../common/enums/NewViewTypeEnum";


export type ITagNameCellRendererProps = {
    asAnchor?: boolean;
    hideTimestamp?: boolean;
    showUom?: boolean;
    showTagDescription?: boolean;
} & ICellRendererParams;

export default function TagNameRenderer({ value,
    data,
    asAnchor,
    hideTimestamp,
    showUom,
    showTagDescription
}: ITagNameCellRendererProps) {

    const navigateTo = useNavigateTo();

    const onNavigate = (url: string, shiftKey: boolean, ctrlKey: boolean) => {

        let options: NavigateToOptions | undefined;

        if (shiftKey || ctrlKey) {
            options = {
                newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
            }
        }

        navigateTo(url, options);
    }

    return (
        <>
            <Box className="ag-cell-value">
                {
                    asAnchor ?
                        <Link
                            sx={{
                                color: "text.primary",
                                fontStyle: data?.disabled ? 'italic' : undefined,
                                //textDecoration: "none",
                                "&:hover": {
                                    cursor: "pointer"
                                },
                                fontWeight: data?.inWriteDownMode ? 600 : undefined
                            }}
                            onClick={(ev) => onNavigate(data?.href, ev.shiftKey, ev.ctrlKey)}
                        >
                            {data?.name}
                        </Link> :
                        //<a href={data?.href}>{data?.name}</a> :
                        showUom ?
                            <>
                                <Box style={{ whiteSpace: 'normal' }}>{value}</Box>
                                <Box style={{ fontStyle: 'italic', fontSize: '.95em' }}>{data.unit}</Box>
                            </>
                            :
                            hideTimestamp ?
                                <Box style={{ whiteSpace: 'normal' }}>{value}</Box> :
                                <>
                                    <Box style={{ whiteSpace: 'normal', fontWeight: data?.inWriteDownMode ? 600 : undefined }}>{value}</Box>
                                    <Box style={{ fontStyle: 'italic', fontSize: '.95em' }}>{data.timestamp}</Box>
                                </>
                }
                {showTagDescription &&
                    <Box
                        sx={{
                            whiteSpace: 'normal',
                            fontStyle: 'italic',
                            color: 'green',
                            marginLeft: '1em',
                            lineHeight: 'normal',
                            marginBottom: "var(--ag-spacing)",
                        }}
                    >
                        {data.tag.tatDescription}
                    </Box>
                }
            </Box>
        </>
    )
}
